// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"89":"6c06f50c","194":"31ffc163","225":"cac3b0bd","439":"36fc757c","531":"ff8a856b","640":"1ddd0e4d"}[chunkId] + ".css";
};